// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./static/js/" + chunkId + ".1790649164897.js?v=1790649164897";
};